// src/common/components/BurgerIcon.tsx
import React, { ButtonHTMLAttributes } from "react";
import classNames from "classnames";
import "../../scss/burgerIcon.scss";

interface BurgerProps extends ButtonHTMLAttributes<HTMLButtonElement> {}

export const Burger: React.FC<BurgerProps> = ({
  className,
  disabled,
  ...rest
}) => {
  const classes = classNames("icon", className, {
    "icon--disabled": disabled,
  });

  return (
    <button
      type="button"
      className={classes}
      disabled={disabled}
      {...rest}
    >
      <div className="icon__line" />
    </button>
  );
};
